/**
 * The camera QR scanner on the join page, bundled instead of loaded from a CDN.
 *
 * Its own bundle rather than part of `qrcode.ts`: this library carries a whole
 * barcode decoder and is by far the largest thing either games page loads, and the
 * room page — which people sit on, polling every two seconds — has no use for it.
 *
 * The page already degrades when this is absent, telling the user to paste the
 * link instead, so a deploy without a web build loses the camera and nothing else.
 */

import { Html5QrcodeScanner } from 'html5-qrcode';

declare global {
  interface Window {
    Html5QrcodeScanner: typeof Html5QrcodeScanner;
  }
}
window.Html5QrcodeScanner = Html5QrcodeScanner;
